import dJSON from 'dirty-json';

import Splide from '@splidejs/splide';

const moduleSelector = '.industry-boxes';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.splide__list').insertAdjacentHTML('beforeend', /* html */ `
          <div class="splide__slide">
            <div class="industry-boxes__card">
              ${item.background ? `<div class="industry-boxes__media">
                <img class="industry-boxes__image" src="${item.background}" alt="${item.title || ''}">
              </div>` : ''}
              <div class="industry-boxes__title-bar">
                <p class="industry-boxes__kicker">Experts In</p>
                ${item.title ? `<h3 class="industry-boxes__title">${item.title}</h3>` : ''}
              </div>
              <div class="industry-boxes__overlay">
                ${item.icon ? `<div class="industry-boxes__icon">
                  <img class="industry-boxes__icon-image" src="${item.icon}" alt="">
                </div>` : ''}
                ${item.title ? `<h3 class="industry-boxes__title">${item.title}</h3>` : ''}
                ${item.text ? `<p class="industry-boxes__text">${item.text}</p>` : ''}
                ${item.link ? `<a href="${item.link}" class="industry-boxes__button btn-custom primary">Find Out More</a>` : ''}
              </div>
            </div>
          </div>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

(() => {
  document.querySelectorAll(`${moduleSelector} .splide`).forEach((item) => {
    const slideCount = item.querySelectorAll('.splide__slide').length;

    const slider = new Splide(item, {
      type: 'slide',
      rewind: true,
      perPage: 6,
      perMove: 1,
      gap: 20,
      drag: false,
      pagination: false,
      arrows: slideCount > 6,
      breakpoints: {
        1500: {
          perPage: 5,
          arrows: slideCount > 5,
          drag: slideCount > 5,
        },
        1200: {
          perPage: 4,
          arrows: slideCount > 4,
          drag: slideCount > 4,
        },
        991: {
          perPage: 3,
          arrows: slideCount > 3,
          drag: slideCount > 3,
        },
        768: {
          perPage: 2,
          arrows: slideCount > 2,
          drag: slideCount > 2,
        },
        576: {
          perPage: 1,
          arrows: slideCount > 1,
          drag: slideCount > 1,
        },
      },
    });
    slider.mount();
  });
})();
